import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useState } from "react";
import apiService from "../services/api.service";
import { useHistory } from "react-router-dom";
import FlashAlert from "../Components/FlashAlert/FlashAlert";
import "./login.css";

const CreateEvent = () => {
  const [date, setDate] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [embedLink, setEmbedLink] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [successfulRegister, setSuccessfulRegister] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonDisabled(true);
    try {
      await apiService.createEvent(date, name, description, embedLink);
      history.push("/events", { successReason: "Evento aggiunto con successo" });
    } catch (error) {
      console.log(error);
      setFormSubmitted(true);
      setSuccessfulRegister(false);
      setButtonDisabled(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card login-card--wide">
        {formSubmitted && !successfulRegister && (
          <FlashAlert variant="danger">Errore durante la creazione.</FlashAlert>
        )}
        <h1 className="login-title">Nuovo evento</h1>
        <p className="login-subtitle">Inserisci le informazioni dell&apos;evento.</p>
        <Form onSubmit={handleSubmit} className="login-form">
          <Form.Group className="mb-3" controlId="formBasicName">
            <Form.Label>Nome evento</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Inserisci nome evento"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicDescription">
            <Form.Label>Descrizione</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Inserisci descrizione evento"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="eventDate">
            <Form.Label>Data e ora (Roma)</Form.Label>
            <Form.Control
              required
              type="datetime-local"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="eventLink">
            <Form.Label>Link embed</Form.Label>
            <Form.Control
              type="text"
              placeholder="Inserisci il link dell'evento"
              value={embedLink}
              onChange={(e) => setEmbedLink(e.target.value)}
            />
          </Form.Group>
          <Button className="login-submit" size="lg" type="submit" disabled={buttonDisabled}>
            Crea
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default CreateEvent;
